export default "__VITE_ASSET__C8o9Tyi___"